export class Client {

    id: string;
    first_name: string;
    last_name: string;
    sex_id: string;
    better_access: string;
    date_of_birth:string;
    client_key:string;
    active:string;
    inactive:string;
    deleteSchedule:string;
    parent_1_name:string;
    email:string;
    parent_2_name:string;
    parent_2_email:string;
    notes: [
     {
         id: string;
         client_id: string;
         title: string;
         body: string;
         created: string;
         modified: string;
         added: string
     }
 ];
 responses: [
     {
         id: string;
         client_id: string;
         assessment_id: string;
         local_time: string;
         answers: string;
         time_taken:string;
         score: string;
         sensitivity: string;
         specificity: string;
         interpretation: string;
         created: string;
         added: string;
         assessment_short_name: string;
     }
 ];
 Response: [
     {
         id: string;
         client_id: string;
         assessment_id: string;
         local_time: string;
         answers: string;
         time_taken:string;
         score: string;
         sensitivity: string;
         specificity: string;
         interpretation: string;
         created: string;
         added: string;
         assessment_short_name: string;
     }
 ];
 Grouping: any[
 ];
 scheduleList: any[
     
 ];
 practitioners: any[];
 groupings: any[];
 assigned_users: any[];
 assigned_groups: any[];
 aschedules: any[];
 schedules: {
     sent: any[];
     scheduled: any[];
 }
 user:any[];
 selected:false;
 last_assessment: string;
 group_names: string;
 
    constructor(){
 //    constructor(public id: string,
 //    public first_name: string,
 //    public last_name: string,
 //    public sex_id: string,
 //    public date_of_birth:string) { 
    }
  
 }


// WEBPACK FOOTER //
// ./src/models/client.ts